module.exports = __webpack_public_path__ + "static/media/16.38035241.jpg";